import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import LivenChoseImg from 'assets/liven_chose.png';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { goToNextQuestion } from 'bootstrap/onboarding/actions';
import { SaveAnswer } from 'analytics/AllEvents';
import { useFeatures } from 'useFeatures';

import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

export const LivenChose: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(goToNextQuestion(features));
    }, 250);
  };

  return (
    <div className={`${styles.container}`}>
      <h3 className={styles.title}>1,000,000+ people</h3>
      <p className={styles.description}>have chosen Loóna</p>
      <img src={LivenChoseImg} alt="" />
      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
